import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { testimonials } from '../../data/salesContent';
export function TestimonialsSection() {
  return <PageSection labelledBy="testimonials-title" data-id="element-186" data-mp="1ruw81ajznlyx">
      <SectionHeading id="testimonials-title" title="Testimonios" data-id="element-187" data-mp="1rtl7rkpr4wck" />
      <ul className="mt-8 space-y-4" data-id="element-188" data-mp="1mvtb6de5wm21">
        {testimonials.map(t => <li key={t.name} className="rounded-xl border border-carbon-800 border-l-4 border-l-accent-500 bg-carbon-900 p-6" data-id="element-189" data-mp="1iv9grhkz3wjl">
            <figure data-id="element-190" data-mp="1dubpmfhzjs5y">
              <blockquote className="text-base leading-relaxed text-carbon-100 md:text-[17px]" data-id="element-191" data-mp="1dxzlvmetesod">“{t.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-192" data-mp="13xqkzv9voj2n">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 font-display text-base font-extrabold text-carbon-950" data-id="element-193" data-mp="13zjpp50xkt80">
                  {t.initials}
                </span>
                <span className="text-sm" data-id="element-194" data-mp="2y9x3lf53q24z">
                  <span className="block font-semibold text-white" data-id="element-195" data-mp="1t8ls9vpfyzv3">{t.name}</span>
                  <span className="block text-carbon-400" data-id="element-196" data-mp="1y99k2jlhvkqd">{t.location}</span>
                </span>
              </figcaption>
            </figure>
          </li>)}
      </ul>
    </PageSection>;
}